import React from 'react'
import cn from 'classnames'
import {
  Tile,
  TileOverlay,
  TileCaption,
  Button,
  useResponsiveHandler,
} from '@mc/design-system'
import { usePrimaryCta, useAnnualPass } from '@mc/growth'
import { useTranslation } from '@mc/i18n'
import { trackGoldStandardPurchaseClick } from '@mc/pre-paywall-events'
import { PricingText } from 'components/PricingText'

export const EndScreen = ({ pageType }: { pageType: string }) => {
  const { t } = useTranslation('@mc/next')
  const { ltSM } = useResponsiveHandler()
  const { ctaHref, ctaCopy } = usePrimaryCta()
  const annualPass = useAnnualPass()

  // Middle-funnel CTA (post-paywall video player). Gold standard is ad-safe:
  // the member gate suppresses ad partners for logged-in users.
  const trackPurchaseClick = () => {
    trackGoldStandardPurchaseClick({
      action: ctaCopy,
      location: 'video-player',
      href: ctaHref,
      purchaseClickProps: {
        category: 'video-player',
        page_type: pageType,
        class_type: 'camp',
      },
      annualPass,
    })
  }

  return (
    <Tile className='mc-h-100'>
      <TileOverlay type='solid' />
      <TileCaption
        position={ltSM ? 'center top' : 'center'}
        className={cn({ 'd-sm-flex': !ltSM })}
      >
        <h4
          className={cn(
            'mc-mb-2',
            { 'mc-text-h4': !ltSM },
            { 'mc-text-h6': ltSM },
          )}
        >
          {t('sessions.endScreen.title')}
        </h4>
        <p
          className={cn(
            { 'mc-mb-8': !ltSM },
            { 'mc-mb-2': ltSM },
            { 'mc-text-small': ltSM },
          )}
        >
          <PricingText />
        </p>
        <Button
          render={<a href={ctaHref} />}
          onClick={trackPurchaseClick}
          size={ltSM ? 'sm' : 'md'}
        >
          {ctaCopy}
        </Button>
      </TileCaption>
    </Tile>
  )
}
